/** Navbar height, matching `NavigationMenu`'s own `tw-min-h-[72px]`. */
export const NAVBAR_HEIGHT = 72;

/**
 * Matches the design system's own `tw-z-[1030]` on the nav, so the bar keeps its
 * backdrop while the page — and the hero's fixed panel — scroll beneath it.
 */
export const STICKY_NAVBAR_CLASSES = "tw-sticky tw-top-0 tw-z-[1030]";
